// @ts-nocheck
import $ from "jquery";

export default class Request {
    constructor() { }

    public async post(url: string, data: any = {}): Promise<any> {
        let request = () => {
            return new Promise<any>((resolve) => {
                $.ajax({
                    url: url,
                    type: "POST",
                    data: data
                }).always(function (res: any) {
                    resolve(res);
                });
            });
        }

        return await request();
    }

}
